import { render, staticRenderFns } from "./XiaoQiNews.vue?vue&type=template&id=3b316501&scoped=true"
import script from "./XiaoQiNews.vue?vue&type=script&lang=js"
export * from "./XiaoQiNews.vue?vue&type=script&lang=js"
import style0 from "./XiaoQiNews.vue?vue&type=style&index=0&id=3b316501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b316501",
  null
  
)

export default component.exports